/* eslint no-undef: 0 */
import AdsMappersFactory from '../../ads/Mappers/factory.js'
import {SearchMappersFactory} from '../Mappers/factory.js'
import {SearchValueObjectsFactory} from '../ValueObjects/factory.js'
import {LocalStorageSearchRepository} from './LocalStorageSearchRepository.js'

export class SearchRepositoriesFactory {
  /**
   * @method
   * @return {LocalStorageSearchRepository}
   * @param {Object} deps
   * @param {adsRawListToAdsListVOMapper} deps.adsRawListToAdsListVOMapper
   * @param {Object} deps.config
   * @param {Storage} deps.localStorage
   * @param {ValueObject} deps.navigationDataValueObject
   * @param {navigationDataVOToNavigationLinksVOMapper} deps.navigationDataVOToNavigationLinksVOMapper
   */
  static localStorageSearchRepository = ({config}) => {
    return new LocalStorageSearchRepository({
      adsRawListToAdsListVOMapper: AdsMappersFactory.adsRawListToAdsListVOMapper({config}),
      config,
      localStorage,
      navigationDataValueObject: SearchValueObjectsFactory.navigationDataValueObject,
      navigationDataVOToNavigationLinksVOMapper: SearchMappersFactory.navigationDataVOToNavigationLinksVOMapper({
        config
      })
    })
  }
}
